<template>
  <centered-content logo="/logo.png">
    <v-col cols="12" sm="8" md="6">
      <v-card :loading="loading ? 'accent' : false">
        <v-toolbar dark flat class="error">
          <v-toolbar-title>Error</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-alert border="left" :icon="errorIcon" dark color="error">There was an issue with your login, please try again.</v-alert>
        </v-card-text>
      </v-card>
    </v-col>
  </centered-content>
</template>

<script>
import CenteredContent from '@/components/CenteredContent'
import { mdiAlertCircle } from '@mdi/js'

export const ROUTE_NAME = 'LoginUser'

export default {
  name: ROUTE_NAME,
  components: {
    CenteredContent
  },
  computed: {
    errorIcon () {
      return mdiAlertCircle
    }
  }
}
</script>
